import * as React from 'react';
import styleNames from 'classnames';
import './stepText.module.scss';

type Props = {
    children: any;
    className?: string;
    styleName?: string;
    fontSize?: 'normal' | 'large';
};

export const StepText = ({ children, className, fontSize = 'normal' }: Props) => {
    const stepTextClasses = styleNames('step-text', {
        normal: fontSize === 'normal',
        large: fontSize === 'large',
    });

    return (
        <div styleName={stepTextClasses} className={className}>
            {children}
        </div>
    );
};
